const GraphPropertyUnitType = {
	NONE: {
		name: "",
		shortname: "kg/m²",
		prefix: "",
		suffix: ""
	},
	KILOGRAMS_PER_METER_SQUARED: {
		name: "Kilograms per mtr²",
		shortname: "kg/m²",
		prefix: "",
		suffix: " kg/m²"
	},
	METERS: {
		name: "Meters",
		shortname: "mtrs",
		prefix: "",
		suffix: " mtrs"
	},
	METERS_PER_SECOND: {
		name: "Meters per second",
		shortname: "mtrs/sec",
		prefix: "",
		suffix: " mtrs/sec"
	},
	KILOMETERS: {
		name: "Kilometers",
		shortname: "km",
		prefix: "",
		suffix: " km"
	},
	DEGREES: {
		name: "Degrees",
		shortname: "°",
		prefix: "",
		suffix: "°"
	},
	DEGREES_CELCIUS: {
		name: "Degrees (Celcius)",
		shortname: "°C",
		prefix: "",
		suffix: "°C"
	},
	DEGREES_FAHRENHEIT: {
		name: "Degrees (Fahrenheit)",
		shortname: "°F",
		prefix: "",
		suffix: "°F"
	},
	HECTOPASCAL: { // air pressure
		name: "Hectopascal",
		shortname: "hPa",
		prefix: "",
		suffix: " hPa"
	},
	PERCENTAGE: { // air pressure
		name: "Percent",
		shortname: "%",
		prefix: "",
		suffix: "%"
	},
	PERCENTAGE_NORMALISED: { // 0.0 - 1.0
		name: "Percent",
		shortname: "%",
		prefix: "",
		suffix: "%"
	},
	SECONDS: {
		name: "Seconds",
		shortname: "secs",
		prefix: "",
		suffix: " secs"
	}
};
export default GraphPropertyUnitType;
